import sensors from 'sa-sdk-javascript'
import url from 'url'
import {appendQuery} from '@/utils'
import MobileDetect from 'mobile-detect'
const env = process.env.VUE_APP_WEB
let query = url.parse(window.location.href, true).query

const defaultSaConfig = {
  local: {
    server_url: 'https://test-sensors-api.baidao.com/sa',
    token: '123wieu',
    project: 'rjhy_huntianling_test',
    project_id: 'htz_wechat'
  },
  integration: {
    server_url: 'https://test-sensors-api.baidao.com/sa',
    token: '123wieu',
    project: 'rjhy_huntianling_test',
    project_id: 'htz_wechat'
  },
  production: {
    server_url: 'https://jc-sensors.baidao.com/sa',
    token: 'Tktt6acg',
    project: 'rjhy_wechatall',
    project_id: 'wechat.all'
  }
}[env]

let saConfig = {
  local: {
    'wechat-common-htz': {
      server_url: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      project_id: 'htz_wechat'
    },
    'wechat-common-jfql': {
      server_url: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      project_id: 'wechat.jfql'
    },
    // 'wechat-common-hyc': {
    //   server_url: 'https://test-sensors-api.baidao.com/sa',
    //   token: '123wieu',
    //   project: 'rjhy_huntianling_test',
    //   project_id: 'htz_wechat'
    // },
  },
  integration: {
    'wechat-common-htz': {
      server_url: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      project_id: 'htz_wechat'
    },
    'wechat-common-jfql': {
      server_url: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      project_id: 'wechat.jfql'
    }
  },
  production: {
    'wechat-common-htz': {
      server_url: 'https://jc-sensors.baidao.com/sa',
      token: '1zRWFX',
      project: 'rjhy_huitouzi',
      project_id: 'htz_wechat'
    },
    'wechat-common-jfql': {
      server_url: 'https://jc-sensors.baidao.com/sa',
      token: 'iueew98',
      project: 'rjhy_huntianling',
      project_id: 'wechat.jfql'
    }
  }
}[env][query.key] || defaultSaConfig

let appData = {
  'wechat-common-htz': {
    // 业务信息
    server_id: 200,
    // 平台号
    platform_id: 'com.rjhy.superstars',
    // 前端类型
    front_type: 'public',
    // 神策项目ID
    project_id: 'htz_wechat'
  },
  'wechat-common-jfql': {
    // 业务信息
    server_id: 200,
    // 平台号
    platform_id: 'wechat.jfql',
    // 前端类型
    front_type: "public",
    // 神策项目ID
    project_id: "wechat.jfql"
  }
}[query.key]

const formatWechatInfo = (wechatData) => {
  if (!wechatData) return
  let {unionid='', username='', subscribe = 0, nickname='', phone = '', sex = 0, headImgUrl = '', openid = '', country = '', city = '', province = ''} = wechatData
  let userAgent = navigator.userAgent
  let md = new MobileDetect(userAgent)
  let os = md.os() // 获取系统
  return {
    username,  // 用户名称，
    nickname, // 微信昵称
    wx_follow: subscribe, // 是否关注公众号 0否 1是
    phone_bind: phone ? 1 : 0, // 是否绑定手机号 0否 1是
    gender: sex, // 性别 0未知 1男2女
    headimgurl: headImgUrl || '', // 头像
    union_id: unionid || '', // 用户union_id
    open_id: openid || '',
    country,
    province,
    city,
    wechat_version: getWechatVersion(), // 微信版本号
    os,
    model: '',  // 设备型号
    os_version: '', // 操作系统
    within_wechat: true
  }
}

const is_weixin = () => {
  let ua = navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i) == "micromessenger") {
    return true
  } else {
    return false
  }
}

const getWechatVersion = () => {
  let version = ""
  if (is_weixin()) {
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d]+)/i)
    if(wechatInfo && wechatInfo.length > 1){
      // 获取微信的版本号
      version = wechatInfo && wechatInfo[1]
    }
  }
  return version
}


// 去除连续的11位数字
function brushWind (obj) {
  if (typeof obj !== 'object') return
  for (let key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = obj[key].replace(/\d{11}/g, '')
    }
  }
  return obj
}
class Sa {
  constructor () {
    this.userId = null
    this.platform = null
    this.cbs = []
    this.channels = ['服务号', '企业号', '订阅号', '其他']
    this.wechatData = null
  }
  init ({userId} = {}, wechatData) {
    console.log('sa init....')
    let {server_url, token, project} = saConfig
    this.userId = userId
    this.wechatData = Object.assign(wechatData)
    let wechatConfig= formatWechatInfo(this.wechatData)
    wechatConfig = brushWind(wechatConfig)
    sensors.init({
      server_url: appendQuery(server_url, { token, project }),
      heatmap_url: 'https://static.sensorsdata.cn/sdk/1.12.5/heatmap.min.js',
      web_url: '神策分析后台地址',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'not_collect'
      }
    })
    sensors.login(userId)
    sensors.quick('autoTrack', {
      'project_id': saConfig.projectId,
      'user_agent': navigator.userAgent,
      'userId': userId,
      ...wechatConfig
    })
    // this.cbFn()
  }
  // cbFn () {
  //   if (!this.cbs.length) return
  //   this.cbs.forEach(i => {
  //     const {event, properties} = i
  //     this.requestTrack(event, properties)
  //   })
  //   this.cbs = []
  // }
  track (event, properties = {}) {
    if (!this.userId) return this.cbs.push({event, properties})
    this.requestTrack(event, properties)
  }
  trackSaEn (event, properties = {}) {
    let params = {
      'otime': new Date().getTime(),
      ...properties,
      ...appData
    }
    this.requestTrack(event, params)
  }
  requestTrack (event, properties) {
    const wechatConfig= formatWechatInfo(this.wechatData)
    let obj = Object.assign({
      'project_id': saConfig.projectId,
      ...wechatConfig
    }, properties)
    obj = brushWind(obj)
    sensors.track(event, obj)
  }
}
export default {
  install (Vue) {
    Vue.prototype.$sa = new Sa()
  }
}
